import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => createStyles({
  btn: {
    padding: '25px',
    backgroundColor: '#CD0021',
    color: '#ffffff',
    fontWeight: 500,
    fontSize: '24px',
    lineHeight: '36px',
    textAlign: 'center',
    border: 'none',
    outline: 'none',
    cursor: 'pointer',
    position: 'relative',
    maxWidth: '613px',
    width: '100%',
    '&:disabled': {
      color: 'rgba(0, 0, 0, 0.26)',
      boxShadow: 'none',
      backgroundColor: 'rgba(0, 0, 0, 0.12)',
      '& svg': {
        filter: 'invert(97%) sepia(0%) saturate(2219%) hue-rotate(18deg) brightness(79%) contrast(102%)',
        opacity: 0.2,
      },
    },
    '& svg': {
      position: 'absolute',
      top: '50%',
      right: '38px',
      transform: ' translateY(-50%)',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '20px',
      fontSize: '20px',
      lineHeight: '30px',
      '& svg': {
        right: '50px',
      },
    },
  },
}));

export default useStyles;
